var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model.lazy",value:(_vm.model),expression:"model",modifiers:{"lazy":true}}],key:"input",staticClass:"time-input",attrs:{"type":"time"},domProps:{"value":(_vm.model)},on:{"change":function($event){_vm.model=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }